"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const short_uuid_1 = __importDefault(require("short-uuid"));
const shallowCompare_1 = __importDefault(require("../shared/shallowCompare"));
const applicationRoutingStackEnsureMaxLenghtNotExceeded_1 = __importDefault(require("../shared/applicationRoutingStackEnsureMaxLenghtNotExceeded"));
const getCurrentRouteFromStack = (stack) => {
    if (!stack) {
        return undefined;
    }
    return stack[stack.length - 1];
};
const buildRoutingHandler = ({ maxRoutesOnStack, getRoutingStack, onSetRoutingStack: originalStackSetter, }) => {
    const changeListeners = [];
    const buildRouteKey = () => short_uuid_1.default.generate();
    const onSetRoutingStack = (newStack) => {
        const validatedStack = (0, applicationRoutingStackEnsureMaxLenghtNotExceeded_1.default)({
            maxRoutesOnStack,
            stack: newStack,
        });
        originalStackSetter(validatedStack);
    };
    const getCurrentRoute = () => getCurrentRouteFromStack(getRoutingStack());
    const callListeners = (newStack) => {
        const currentRoute = getCurrentRouteFromStack(newStack);
        if (!currentRoute) {
            return;
        }
        const { pageId, transition, params, } = currentRoute;
        changeListeners.forEach((listener) => {
            listener({
                pageId,
                transition,
                params,
            });
        });
    };
    const goBack = () => {
        const stack = getRoutingStack();
        if (stack && stack.length > 1) {
            const newStack = [...stack];
            newStack.pop();
            onSetRoutingStack(newStack);
            callListeners(newStack);
        }
    };
    const push = ({ pageId, transition, params, }) => {
        const stack = getRoutingStack() || [];
        const currentRoute = getCurrentRouteFromStack(stack);
        if ((currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.pageId) === pageId
            && ((currentRoute.params === undefined && params === undefined)
                || (currentRoute.params
                    && params
                    && (0, shallowCompare_1.default)(currentRoute.params)(params)))) {
            return;
        }
        const formatedParams = params || {};
        const newStack = [
            ...stack,
            {
                pageId,
                transition,
                params: formatedParams,
                key: buildRouteKey(),
            },
        ];
        onSetRoutingStack(newStack);
        callListeners(newStack);
    };
    const cleanPreviousAfterReplace = () => {
        const stack = getRoutingStack() || [];
        const currentRoute = getCurrentRouteFromStack(stack);
        if (!stack.length || !currentRoute) {
            return;
        }
        const newStack = [currentRoute];
        onSetRoutingStack(newStack);
    };
    const replaceTop = ({ pageId, transition, params: rawParams, }) => {
        const stack = getRoutingStack();
        const params = rawParams || {};
        if (!stack || stack.length < 1) {
            return;
        }
        onSetRoutingStack([
            ...stack.slice(0, stack.length - 1),
            {
                pageId,
                transition,
                params,
                key: buildRouteKey(),
            },
        ]);
    };
    const updateTransitionCurrentPage = (transition) => {
        const stack = getRoutingStack() || [];
        const currentRoute = getCurrentRouteFromStack(stack);
        if (!stack || stack.length < 1 || !currentRoute) {
            return;
        }
        onSetRoutingStack([
            ...stack.slice(0, stack.length - 1),
            Object.assign(Object.assign({}, currentRoute), { transition }),
        ]);
    };
    const subscribe = (listener) => {
        changeListeners.push(listener);
    };
    const boot = (initialPageId) => {
        const stack = getRoutingStack();
        if (!stack || stack.length < 1) {
            const formatedParams = {};
            onSetRoutingStack([{
                    pageId: initialPageId,
                    params: formatedParams,
                    key: buildRouteKey(),
                }]);
        }
    };
    const getCurrentParams = () => { var _a; return (_a = getCurrentRoute()) === null || _a === void 0 ? void 0 : _a.params; };
    const getCurrentPageId = () => { var _a; return (_a = getCurrentRoute()) === null || _a === void 0 ? void 0 : _a.pageId; };
    const dangerouslySetCurrentPageParam = (paramKey, paramValue) => {
        const stack = getRoutingStack();
        if (!stack) {
            return;
        }
        const currentRoute = getCurrentRouteFromStack(stack);
        if (!currentRoute) {
            return;
        }
        // This is a direct mutation because users
        // do not expect a re-render when a page param is setted
        // so no update is reported from processor and only de value
        // is changed
        currentRoute.params[paramKey] = paramValue;
    };
    const isContainsPrevious = () => {
        const stack = getRoutingStack();
        return !!(stack && stack.length > 1);
    };
    return {
        goBack,
        push,
        cleanPreviousAfterReplace,
        replaceTop,
        subscribe,
        boot,
        getCurrentParams,
        getCurrentPageId,
        dangerouslySetCurrentPageParam,
        updateTransitionCurrentPage,
        isContainsPrevious,
    };
};
exports.default = buildRoutingHandler;
